import { useTranslation } from 'react-i18next';
import { Tabs } from '@oliasoft-open-source/react-ui-library';
import translations from 'client/internationalization/translation-map.json';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { UserAccount } from './user-account';
import { routes } from '../../navigation/routes/routes';
import { UnitSettings } from './unit-settings';
import { GeneralSettingsPageTabIds, SettingsPageIds } from '../settings-constants';

export const GeneralSettings = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();

  const defaultTabId: string = GeneralSettingsPageTabIds.UserAccount;
  const activeTabId = (params.settingsPageTabId || defaultTabId) as GeneralSettingsPageTabIds;

  const tabs = [
    {
      label: t(translations.settings_accountInformation),
      content: UserAccount,
      url: generatePath(routes.userSettingsTabs.pattern.path, { companyId: params.companyId, settingsPageId: SettingsPageIds.General, settingsPageTabId: GeneralSettingsPageTabIds.UserAccount }),
      value: GeneralSettingsPageTabIds.UserAccount,
    },
    {
      label: t(translations.settings_unitSettings),
      content: UnitSettings,
      url: generatePath(routes.userSettingsTabs.pattern.path, { companyId: params.companyId, settingsPageId: SettingsPageIds.General, settingsPageTabId: GeneralSettingsPageTabIds.UnitSettings }),
      value: GeneralSettingsPageTabIds.UnitSettings,
    },
  ];

  const navToTab = (tabId: GeneralSettingsPageTabIds) => {
    const newActiveTab = tabs.find(t => t.value === tabId) || tabs[0];
    navigate(newActiveTab.url);
  };

  const activeTab = tabs.find(t => t.value === activeTabId) || tabs[0];
  const TabContent = activeTab.content;
  const options = tabs.map(tab => ({
    label: tab.label,
    value: tab.value,
  }));
  return (
    <>
      <Tabs
        onChange={(evt) => {
          navToTab(evt.target.value);
        }}
        options={options}
        value={activeTab}
        padding
        margin={false}
      />
      <div>
        <TabContent />
      </div>
    </>
  );
};
